import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=4284fbb1&"
import script from "./loginDialog.vue?vue&type=script&lang=js&"
export * from "./loginDialog.vue?vue&type=script&lang=js&"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=4284fbb1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4284fbb1')) {
      api.createRecord('4284fbb1', component.options)
    } else {
      api.reload('4284fbb1', component.options)
    }
    module.hot.accept("./loginDialog.vue?vue&type=template&id=4284fbb1&", function () {
      api.rerender('4284fbb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginDialog.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/loginDialog.vue
// module id = I+x0
// module chunks = 0